const customAddToCart = async function (event, preorderDate) {
  const addToCartButton = document.getElementById('AddToCart');
  addToCartButton.setAttribute('disabled', 'true');
  addToCartButton.setAttribute('aria-busy', 'true');

  try {
    const variantIdElement = document.querySelector("input[name='id']");
    const variantId = variantIdElement ? variantIdElement.value : null;

    const quantityElement = document.querySelector("input[name='quantity']");
    const quantity = quantityElement ? quantityElement.value || 1 : 1;

    let body = {
      quantity: quantity,
      id: variantId,
    };

    if (preorderDate) {
      body.properties = {
        '_preorder-date': preorderDate,
      };
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const responseJson = await response.json();

    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
        }
      }));

      const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
      const cartContent = await cartResponse.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cartContent }
      }));

      // TH 12-4-24 issues with && !document.querySelector(".drawer") as to openMiniCart on DOGiD, maintaining change here 
      cartContent["sections"] = responseJson["sections"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: window.themeVariables.settings.cartType === "drawer"
        }
      }));
    }

    document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
      bubbles: true,
      cancelable: true,
      detail: {
        status: response.ok ? "success" : "error",
        error: responseJson["description"] || ""
      }
    }));

  } finally {
    addToCartButton.removeAttribute('disabled');
    addToCartButton.setAttribute('aria-busy', 'false');
  }
};

// js/custom-element/ui/rid-native-video.js
var RidNativeVideo = class extends HTMLElement {

  constructor() {
    super();
    this.hasLoaded = false;
    if (this.autoPlay) {
      this.play();
    } else {
      this.addEventListener("click", this.play.bind(this), { once: true });
    }
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  play() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }
    this.querySelector("video")
      .play()
      .then(() => {
      })
      .catch((error) => {
        console.error("Error playing video", error);
        this._showHideEnabledDisabledAutoplaySections();
      });
  }
  pause() {
    if (this.hasLoaded) {
      this.querySelector("video").pause();
    }
  }
  _showHideEnabledDisabledAutoplaySections() {
    const sectionId = this.getAttribute("data-section-id");
    const autoplayEnabledSection = document.getElementById(
      `video-banner-autoplay-enabled-section-${sectionId}`
    );

    const autoplayDisabledSection = document.getElementById(
      `video-banner-autoplay-disabled-section-${sectionId}`
    );

    if (!autoplayEnabledSection || !autoplayDisabledSection) {
      console.error("Autoplay sections not found for section ID:", sectionId);
      return;
    }

    autoplayEnabledSection.style.display = "none";
    autoplayDisabledSection.style.display = "block";

  }
  
  _replaceContent() {
    let node = this.querySelector("template");
    if (!node) {
      return;
    }
    node = node.content.firstElementChild.cloneNode(true);
    if (!this.hasAttribute("autoplay")) {
      this.innerHTML = "";
    }
    this.appendChild(node);
    this.firstElementChild.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });
    this.firstElementChild.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });
    this.hasLoaded = true;
  }
};
window.customElements.define("rid-native-video", RidNativeVideo);

